export const TEAM_REDUCER_NAME = 'team'
export const DOMAIN_USERS_LIST_REDUCER_NAME = 'domainUsersList'
export const DELETE_USER_REDUCER_NAME = 'deleteUser'
export const UPDATE_USER_PERMISSIONS_REDUCER_NAME = 'updateUserPermissions'

export enum TEAM_HEADERS {
  AVATAR = 'avatar',
  NAME = 'name',
  EMAIL = 'email',
  IS_ADMIN = 'isAdmin',
  IS_CONFIG_AUTHOR = 'isConfigAuthor',
  IS_SUBSCRIPTION_MANAGER = 'isSubscriptionManager',
  ID = 'id',
}

export enum UPDATE_PERMISSIONS_ACTIONS {
  UPDATE_ADMIN = 'updateAdmin',
  UPDATE_CONFIG = 'updateConfig',
  UPDATE_SUBSCRIPTION_MANAGEMENT = 'updateSubscriptionManagement',
}
